import { useEffect, useState } from "react";
import { Space, Title, Text, createStyles, Textarea, Alert, Button } from '@mantine/core';
import { beigeColor } from '../../assets/constants';
import FormPaper from '../../components/form-paper/form-paper.component';
import ChangeHistoryVisual from "../../components/change-history-visual/change-history-visual.component";
import { IconAlertCircle } from '@tabler/icons-react';
import { useParams } from 'react-router-dom';

const useStyles = createStyles((theme) => ({

    outerContainer: {
        background: beigeColor,
        minHeight: '100vh',
        padding: '75px 20px',
        [theme.fn.smallerThan('xs')]: {
            background: 'white',
            padding: '0px',
        }
    },

    formContainer: {
        width: '100%',
        maxWidth: '650px',
        margin: '0px auto',
    },

    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

}));

const questionHistories = {
    'human': [{"s":"I","t":1730486733226},{"s":"I ","t":155},{"s":"I w","t":219},{"s":"I wa","t":299},{"s":"I wak","t":350},{"s":"I wake","t":483},{"s":"I wake ","t":557},{"s":"I wake u","t":830},{"s":"I wake up","t":883},{"s":"I wake up,","t":1118},{"s":"I wake up, ","t":1509},{"s":"I wake up, b","t":1795},{"s":"I wake up, br","t":1899},{"s":"I wake up, bru","t":2019},{"s":"I wake up, brus","t":2149},{"s":"I wake up, brush","t":2206},{"s":"I wake up, brush ","t":2384},{"s":"I wake up, brush m","t":2552},{"s":"I wake up, brush my","t":2654},{"s":"I wake up, brush my ","t":2792},{"s":"I wake up, brush my t","t":2982},{"s":"I wake up, brush my te","t":3087},{"s":"I wake up, brush my tee","t":3280},{"s":"I wake up, brush my teet","t":3481},{"s":"I wake up, brush my teeth","t":3551},{"s":"I wake up, brush my teeth,","t":3812},{"s":"I wake up, brush my teeth, ","t":4068},{"s":"I wake up, brush my teeth, a","t":4171},{"s":"I wake up, brush my teeth, an","t":4278},{"s":"I wake up, brush my teeth, and","t":4372},{"s":"I wake up, brush my teeth, and ","t":4468},{"s":"I wake up, brush my teeth, and t","t":4606},{"s":"I wake up, brush my teeth, and th","t":4726},{"s":"I wake up, brush my teeth, and the","t":4808},{"s":"I wake up, brush my teeth, and then","t":4926},{"s":"I wake up, brush my teeth, and then ","t":5114},{"s":"I wake up, brush my teeth, and then g","t":5431},{"s":"I wake up, brush my teeth, and then ge","t":5725},{"s":"I wake up, brush my teeth, and then get","t":5848},{"s":"I wake up, brush my teeth, and then get ","t":5922},{"s":"I wake up, brush my teeth, and then get i","t":6051},{"s":"I wake up, brush my teeth, and then get in","t":6132},{"s":"I wake up, brush my teeth, and then get in ","t":6273},{"s":"I wake up, brush my teeth, and then get in t","t":6344},{"s":"I wake up, brush my teeth, and then get in th","t":6431},{"s":"I wake up, brush my teeth, and then get in the","t":6508},{"s":"I wake up, brush my teeth, and then get in the ","t":6611},{"s":"I wake up, brush my teeth, and then get in the c","t":6707},{"s":"I wake up, brush my teeth, and then get in the ca","t":6843},{"s":"I wake up, brush my teeth, and then get in the car","t":6951},{"s":"I wake up, brush my teeth, and then get in the car ","t":7111},{"s":"I wake up, brush my teeth, and then get in the car a","t":7331},{"s":"I wake up, brush my teeth, and then get in the car an","t":7433},{"s":"I wake up, brush my teeth, and then get in the car and","t":7528},{"s":"I wake up, brush my teeth, and then get in the car and ","t":7613},{"s":"I wake up, brush my teeth, and then get in the car and g","t":7851},{"s":"I wake up, brush my teeth, and then get in the car and go","t":7899},{"s":"I wake up, brush my teeth, and then get in the car and go ","t":8040},{"s":"I wake up, brush my teeth, and then get in the car and go t","t":8150},{"s":"I wake up, brush my teeth, and then get in the car and go to","t":8209},{"s":"I wake up, brush my teeth, and then get in the car and go to ","t":8332},{"s":"I wake up, brush my teeth, and then get in the car and go to w","t":8402},{"s":"I wake up, brush my teeth, and then get in the car and go to wo","t":8510},{"s":"I wake up, brush my teeth, and then get in the car and go to wor","t":8585},{"s":"I wake up, brush my teeth, and then get in the car and go to work","t":8629},{"s":"I wake up, brush my teeth, and then get in the car and go to work.","t":8858}],
    'ai': [
        {
          "s": "I",
          "t": 0
        },
        {
          "s": "I ",
          "t": 63
        },
        {
          "s": "I w",
          "t": 125
        },
        {
          "s": "I wa",
          "t": 186
        },
        {
          "s": "I wak",
          "t": 248
        },
        {
          "s": "I wake",
          "t": 310
        },
        {
          "s": "I wake ",
          "t": 369
        },
        {
          "s": "I wake u",
          "t": 427
        },
        {
          "s": "I wake up",
          "t": 489
        },
        {
          "s": "I wake up ",
          "t": 546
        },
        {
          "s": "I wake up a",
          "t": 604
        },
        {
          "s": "I wake up at",
          "t": 665
        },
        {
          "s": "I wake up at ",
          "t": 724
        },
        {
          "s": "I wake up at 6",
          "t": 784
        },
        {
          "s": "I wake up at 6:",
          "t": 847
        },
        {
          "s": "I wake up at 6:3",
          "t": 906
        },
        {
          "s": "I wake up at 6:30",
          "t": 968
        },
        {
          "s": "I wake up at 6:30 ",
          "t": 1026
        },
        {
          "s": "I wake up at 6:30 A",
          "t": 1086
        },
        {
          "s": "I wake up at 6:30 AM",
          "t": 1148
        },
        {
          "s": "I wake up at 6:30 AM ",
          "t": 1207
        },
        {
          "s": "I wake up at 6:30 AM a",
          "t": 1267
        },
        {
          "s": "I wake up at 6:30 AM an",
          "t": 1327
        },
        {
          "s": "I wake up at 6:30 AM and",
          "t": 1388
        },
        {
          "s": "I wake up at 6:30 AM and ",
          "t": 1447
        },
        {
          "s": "I wake up at 6:30 AM and s",
          "t": 1507
        },
        {
          "s": "I wake up at 6:30 AM and st",
          "t": 1567
        },
        {
          "s": "I wake up at 6:30 AM and sta",
          "t": 1628
        },
        {
          "s": "I wake up at 6:30 AM and star",
          "t": 1687
        },
        {
          "s": "I wake up at 6:30 AM and start",
          "t": 1749
        },
        {
          "s": "I wake up at 6:30 AM and start ",
          "t": 1811
        },
        {
          "s": "I wake up at 6:30 AM and start t",
          "t": 1869
        },
        {
          "s": "I wake up at 6:30 AM and start th",
          "t": 1933
        },
        {
          "s": "I wake up at 6:30 AM and start the",
          "t": 1995
        },
        {
          "s": "I wake up at 6:30 AM and start the ",
          "t": 2055
        },
        {
          "s": "I wake up at 6:30 AM and start the c",
          "t": 2119
        },
        {
          "s": "I wake up at 6:30 AM and start the co",
          "t": 2177
        },
        {
          "s": "I wake up at 6:30 AM and start the cof",
          "t": 2236
        },
        {
          "s": "I wake up at 6:30 AM and start the coff",
          "t": 2291
        },
        {
          "s": "I wake up at 6:30 AM and start the coffe",
          "t": 2350
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee",
          "t": 2415
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee ",
          "t": 2479
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee m",
          "t": 2536
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee ma",
          "t": 2594
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee mak",
          "t": 2655
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee make",
          "t": 2712
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker",
          "t": 2772
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker.",
          "t": 2830
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. ",
          "t": 2890
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. W",
          "t": 2946
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. Wh",
          "t": 3004
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. Whi",
          "t": 3064
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. Whil",
          "t": 3125
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While",
          "t": 3190
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While ",
          "t": 3250
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While i",
          "t": 3313
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it",
          "t": 3373
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it ",
          "t": 3434
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it b",
          "t": 3494
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it br",
          "t": 3559
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it bre",
          "t": 3619
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brew",
          "t": 3679
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews",
          "t": 3741
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews,",
          "t": 3804
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, ",
          "t": 3866
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I",
          "t": 3927
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I ",
          "t": 3990
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I h",
          "t": 4052
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I ha",
          "t": 4111
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I han",
          "t": 4170
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I hand",
          "t": 4232
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handl",
          "t": 4290
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle",
          "t": 4352
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle ",
          "t": 4412
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle m",
          "t": 4468
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my",
          "t": 4527
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my ",
          "t": 4584
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my m",
          "t": 4643
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my mo",
          "t": 4701
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my mor",
          "t": 4761
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morn",
          "t": 4817
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morni",
          "t": 4875
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my mornin",
          "t": 4937
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning",
          "t": 4999
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning ",
          "t": 5061
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning h",
          "t": 5122
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hy",
          "t": 5180
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hyg",
          "t": 5242
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygi",
          "t": 5307
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygie",
          "t": 5366
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygien",
          "t": 5428
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene",
          "t": 5490
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene ",
          "t": 5548
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene r",
          "t": 5612
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene ro",
          "t": 5678
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene rou",
          "t": 5736
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene rout",
          "t": 5795
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routi",
          "t": 5854
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routin",
          "t": 5916
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine",
          "t": 5975
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine.",
          "t": 6030
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. ",
          "t": 6087
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. A",
          "t": 6149
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. Af",
          "t": 6210
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. Aft",
          "t": 6273
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. Afte",
          "t": 6333
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After",
          "t": 6395
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After ",
          "t": 6455
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a",
          "t": 6515
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a ",
          "t": 6572
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a s",
          "t": 6633
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a sh",
          "t": 6695
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a sho",
          "t": 6753
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a show",
          "t": 6811
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a showe",
          "t": 6869
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower",
          "t": 6927
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower ",
          "t": 6988
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower a",
          "t": 7047
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower an",
          "t": 7109
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and",
          "t": 7166
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and ",
          "t": 7226
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and g",
          "t": 7283
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and ge",
          "t": 7344
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and get",
          "t": 7402
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and gett",
          "t": 7457
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getti",
          "t": 7514
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and gettin",
          "t": 7573
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting",
          "t": 7633
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting ",
          "t": 7689
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting d",
          "t": 7748
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dr",
          "t": 7810
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dre",
          "t": 7870
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dres",
          "t": 7930
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dress",
          "t": 7990
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dresse",
          "t": 8049
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed",
          "t": 8111
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed,",
          "t": 8170
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, ",
          "t": 8234
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I",
          "t": 8292
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I ",
          "t": 8352
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I h",
          "t": 8410
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I ha",
          "t": 8474
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I hav",
          "t": 8537
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have",
          "t": 8595
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have ",
          "t": 8656
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have m",
          "t": 8718
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my",
          "t": 8779
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my ",
          "t": 8839
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my c",
          "t": 8898
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my co",
          "t": 8957
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my cof",
          "t": 9016
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coff",
          "t": 9080
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffe",
          "t": 9141
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee",
          "t": 9201
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee ",
          "t": 9257
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee a",
          "t": 9321
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee an",
          "t": 9380
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and",
          "t": 9442
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and ",
          "t": 9502
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a",
          "t": 9563
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a ",
          "t": 9623
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a q",
          "t": 9679
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a qu",
          "t": 9738
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a qui",
          "t": 9799
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quic",
          "t": 9860
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick",
          "t": 9917
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick ",
          "t": 9974
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick b",
          "t": 10034
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick br",
          "t": 10090
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick bre",
          "t": 10154
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick brea",
          "t": 10216
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick break",
          "t": 10277
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakf",
          "t": 10332
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfa",
          "t": 10390
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfas",
          "t": 10453
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast",
          "t": 10515
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast ",
          "t": 10577
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast b",
          "t": 10640
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast be",
          "t": 10701
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast bef",
          "t": 10756
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast befo",
          "t": 10817
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast befor",
          "t": 10877
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before",
          "t": 10935
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before ",
          "t": 10994
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before h",
          "t": 11050
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before he",
          "t": 11109
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before hea",
          "t": 11166
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before head",
          "t": 11225
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before headi",
          "t": 11286
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before headin",
          "t": 11343
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading",
          "t": 11402
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading ",
          "t": 11464
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading o",
          "t": 11522
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading ou",
          "t": 11581
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out",
          "t": 11645
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out ",
          "t": 11706
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out a",
          "t": 11766
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out at",
          "t": 11830
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out at ",
          "t": 11888
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out at 8",
          "t": 11948
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out at 8 ",
          "t": 12008
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out at 8 A",
          "t": 12065
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out at 8 AM",
          "t": 12127
        },
        {
          "s": "I wake up at 6:30 AM and start the coffee maker. While it brews, I handle my morning hygiene routine. After a shower and getting dressed, I have my coffee and a quick breakfast before heading out at 8 AM.",
          "t": 12188
        }
      ],
      'hybrid': [{"s":"/","t":1730487053357},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving into work.\n","t":1750},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving into work.","t":2912},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving into work","t":3400},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving into wor","t":3480},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving into wo","t":3564},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving into w","t":3651},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving into ","t":3736},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving into","t":3820},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving int","t":3902},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving in","t":3987},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving i","t":4069},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving ","t":4151},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before diving","t":4235},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before divin","t":4321},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before divi","t":4404},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before div","t":4486},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before di","t":4569},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before d","t":4656},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before ","t":4740},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start before","t":4823},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start befor","t":4905},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start befo","t":4988},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start bef","t":5070},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start be","t":5153},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start b","t":5239},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start ","t":5323},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional start","t":5407},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional star","t":5488},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional sta","t":5572},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional st","t":5657},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional s","t":5741},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional ","t":5826},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentional","t":5910},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentiona","t":5996},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intention","t":6078},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intentio","t":6161},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intenti","t":6245},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, intent","t":6330},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, inten","t":6411},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, inte","t":6494},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, int","t":6578},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, in","t":6662},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, i","t":6745},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm, ","t":6829},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm,","t":7088},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm","t":7411},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm ","t":7766},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm s","t":7987},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm st","t":8097},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm sta","t":8409},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm star","t":8522},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm start","t":8770},{"s":"Each morning, I start by waking up to my alarm around 6:30 a.m. I spend a few minutes stretching to wake up my body, then head to the kitchen to drink a glass of water and make coffee. While the coffee brews, I take a few minutes for mindfulness—either some light meditation or setting intentions for the day. After that, I sip my coffee as I review my calendar and check for any urgent emails. Once I’m caught up, I make a quick, balanced breakfast and get ready for the day ahead. My goal is to have a calm start.","t":8946}]
}

const KeystrokePublic = () => {

    const [questionHistory, setQuestionHistory] = useState([]);
    const { classes } = useStyles();
    const { questionId } = useParams();

    useEffect(() => {
        if (questionId && questionHistories[questionId]) {
            // Convert every s to "state" and every "t" to "time_since_start"
            questionHistories[questionId].forEach(entry => {
                entry.state = entry.s;
                entry.time_since_start = entry.t;
                delete entry.s;
                delete entry.t;
            });
            setQuestionHistory(questionHistories[questionId]);
        }
    }, [questionId]);

    return (
        <div className={classes.outerContainer}>
            <div className={classes.formContainer}>
                <FormPaper>
                    <Title order={3} weight={500}>Text Change Visualizer</Title>
                    <Space h={5} />
                    <Text>
                        This visualizer replays the recorded keystroke history for a recorded open-ended question. It shows the text as it was typed, character by character, and the time taken to type each character.
                    </Text>
                    <Space h='xl' />
                    {
                        questionHistory.length > 0 &&
                        <ChangeHistoryVisual
                            questionHistory={questionHistory}
                            questionText='Describe your morning routine in detail.'
                        />
                    }
                </FormPaper>
            </div>
        </div>
    )
}

export default KeystrokePublic;